module.exports = __webpack_public_path__ + "img/IETips.f74523bb.png";